import { QueueClassEnumType } from '@mark43/cad-api';
import { globalAttributes } from '../../common/global-attributes';

const queueClassToAgencyTypeGlobalAttribute: Record<
    QueueClassEnumType,
    typeof globalAttributes.agencyTypeGlobal[keyof typeof globalAttributes.agencyTypeGlobal]
> = {
    POLICE: globalAttributes.agencyTypeGlobal.POLICE,
    FIRE: globalAttributes.agencyTypeGlobal.FIRE,
    MEDICAL: globalAttributes.agencyTypeGlobal.EMS,
};

export function mapQueueClassesToAgencyTypeGlobalAttributes(
    queueClasses: QueueClassEnumType[]
): number[] {
    return queueClasses.map((queueClass) => queueClassToAgencyTypeGlobalAttribute[queueClass]);
}
